<template>
	<!-- Shipping Labels -->
	<modal class="packing-slips-modal" :size="size" @close="$emit('close')">
		<template slot="header">
			<h3>
				<i class="material-icons text-primary">description</i>
				<b>Shipping Labels</b>
			</h3>
		</template>
		<div slot="body" class="row">
			<div
				class="packing-slip-config"
				:class="{ 'col-lg-6 ': isPreviewVisible, 'col-12': !isPreviewVisible }"
			>
				<!-- <div
					class="callout callout--warning"
					v-if="store && (store.name === '' || store.phone === '')"
				>
					<div class="callout__content">
						Please update your store information in Store Settings, or click
						<router-link :to="{ name: 'settingsStore' }">here</router-link>
					</div>
				</div> -->
				<!-- invalid receipt_number orders -->
				<div
					class="alert alert-danger"
					role="alert"
					v-if="invalidOrders.length > 0"
				>
					<h4 class="mb-3">Order COD berikut tidak memiliki Nomor Resi:</h4>
					<div
						class="mb-2"
						v-for="(order, index) in invalidOrders"
						:key="index"
					>
						{{ index + 1 }}. <strong>#{{ order.order_id }}</strong> -
						<span>{{ order.customer_data.name }}</span> -
						<span>{{ order.shipping.courier }}</span>
					</div>
				</div>
				<div class="row">
					<!-- Layouts -->
					<div class="col-12">
						<div class="form-group">
							<label
								><b>{{ $t('Shipping Label Layouts') }}</b></label
							>
							<select
								class="form-control"
								@change="onLayoutChange"
								v-model="template"
							>
								<option
									v-for="option in availableTemplates"
									:key="option.value"
									:value="option.value"
								>
									{{ option.label }}
								</option>
							</select>
							<div class="page-info mt-2 callout callout--info flex-center">
								<i class="material-icons md-18 mr-1">info</i>
								<span class="mr-1">{{ $t('Page Size') }}:</span>
								<!-- Layout 3 -->
								<span v-if="template === 'thermal'"
									>100 mm x 120 mm (width x height)</span
								>
								<!-- Layout 4 -->
								<span v-if="template === 'thermal-small'"
									>80 mm x 50 mm (width x height)</span
								>
								<!-- Layout 5 -->
								<span v-if="template === 'thermal-large'"
									>100 mm x 150 mm (width x height)</span
								>
								<!-- Layout 6 -->
								<span v-if="template === 'thermal-layout-6'"
									>100 mm x 150 mm (width x height)</span
								>
								<!-- Layout 1 & 2 -->
								<span v-if="template === 'default' || template === 'boxed'"
									>A4</span
								>
							</div>
						</div>
					</div>
					<!-- Options -->
					<div class="col-12">
						<div class="well mb-3">
							<div class="row">
								<!-- disabled karena tidak digunakan -->
								<!-- Sender Source
								<div class="col-md-4">
									<div class="form-group">
										<label
											><b>{{ $t('Sender') }}</b></label
										>
										<select
											class="form-control"
											@change="onSenderChange"
											v-model="senderSource"
										>
											<option value="store">{{ $t('Store') }}</option>
											<option value="cs">{{ $t('CS') }}</option>
										</select>
									</div>
								</div>
								Name
								<div class="col-md-4">
									<div class="form-group">
										<label
											><b>{{ $t("Sender's Name") }}</b></label
										>
										<input
											type="text"
											name="sender_name"
											class="input form-control"
											placeholder=""
											@change="onSenderNameChange"
											v-model="sender.name"
										/>
									</div>
								</div>
								Phone
								<div class="col-md-4">
									<div class="form-group">
										<label
											><b>{{ $t("Sender's Phone") }}</b></label
										>
										<input
											type="url"
											name="sender_phone"
											class="input form-control"
											placeholder=""
											@change="onSenderPhoneChange"
											v-model="sender.phone"
										/>
									</div>
								</div> -->
								<!-- Address -->
								<div class="col-md-4 hidden">
									<div class="form-group">
										<label
											><b>{{ $t("Sender's Address") }}</b></label
										>
										<div class="form-group">
											<label>
												<!-- <input type="checkbox" class="input-checkbox" v-model="isSenderAddressVisible"> -->
												<input
													type="checkbox"
													class="input-checkbox"
													v-model="settingShippingLabel.senderAddress"
												/>
												<span></span>
												<span class="input-checkbox-text">{{
													$t("Show sender's address")
												}}</span>
											</label>
										</div>
									</div>
								</div>

								<!-- Logo -->
								<div class="col-md-4">
									<div class="form-group">
										<label
											><b>{{ $t("Sender's Logo") }}</b></label
										>
										<label>
											<!-- <input type="checkbox" class="input-checkbox" v-model="isShowLogo" :disabled="!logo || logo === ''"> -->
											<input
												type="checkbox"
												class="input-checkbox"
												value="logo"
												v-model="settings"
												:disabled="!logo || logo === ''"
											/>
											<span></span>
											<span class="input-checkbox-text">
												<span>Print store logo</span>
												<img
													class="packing-slip-logo-preview ml-3"
													:src="storeLogo"
													crossorigin="anonymous"
													@load="onLogoLoaded"
													v-if="store"
												/>
											</span>
										</label>
									</div>
								</div>

								<!-- Sender's Phone -->
								<div class="col-md-4">
									<label><b>Show Sender's Phone</b></label>
									<div class="form-group">
										<label>
											<input
												type="checkbox"
												class="input-checkbox"
												v-model="settingShippingLabel.senderPhone"
											/>
											<span></span>
											<span class="input-checkbox-text"
												>Show Sender's Phone</span
											>
										</label>
									</div>
								</div>

								<!-- OO Logo -->
								<!-- <div class="col-md-4">
									<label><b>Ostock</b></label>
									<div class="form-group">
										<label>
											<input
												type="checkbox"
												class="input-checkbox"
												value="oo_logo"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text"
												>Show Ostock's Logo</span
											>
										</label>
									</div>
								</div> -->

								<!-- Instructions -->
								<div class="col-md-4" v-if="template === 'thermal-large' || template === 'thermal-layout-6'">
									<label
										><b>{{ $t('Instructions') }}</b></label
									>
									<div class="form-group">
										<label>
											<input
												type="checkbox"
												class="input-checkbox"
												value="instructions"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text">Show Instructions</span>
										</label>
									</div>
								</div>

								<!-- Website -->
								<div class="col-md-4 hidden">
									<div class="form-group">
										<label><b>Website (Optional)</b></label>
										<input
											type="url"
											name="sender_website"
											class="input form-control"
											placeholder=""
											v-model="sender.website"
										/>
									</div>
								</div>
							</div>
						</div>
						<div class="well">
							<div class="row">
								<!-- Product -->
								<div class="col-md-4">
									<label><b>Product</b></label>
									<div class="form-group">
										<label>
											<!-- <input type="checkbox" class="input-checkbox" v-model="isShowProductInformation"> -->
											<input
												type="checkbox"
												class="input-checkbox"
												value="product"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text"
												>Show product information</span
											>
										</label>
									</div>
								</div>

								<!-- Mask Product Name -->
								<div class="col-md-4">
									<div class="form-group">
										<label
											><b>{{ $t('Product Name') }}</b></label
										>
										<div class="form-group">
											<label>
												<input
													type="checkbox"
													class="input-checkbox"
													value="hide_product_name"
													v-model="settings"
													:disabled="isUseProductSupplierName"
												/>
												<span></span>
												<span class="input-checkbox-text">{{
													$t('Use Product Code')
												}}</span>
											</label>
										</div>
										<div class="form-group">
											<label>
												<input
													:disabled="isUseProductCode"
													type="checkbox"
													class="input-checkbox"
													v-model="settingShippingLabel.useProductSupplierName"
												/>
												<span></span>
												<span class="input-checkbox-text">{{
													$t('Use Supplier Product')
												}}</span>
											</label>
										</div>
									</div>
								</div>

								<!-- Product Weight -->
								<div class="col-md-4">
									<label><b>Product Weight</b></label>
									<div class="form-group">
										<label>
											<!-- <input type="checkbox" class="input-checkbox" v-model="isWeightVisible"> -->
											<input
												type="checkbox"
												class="input-checkbox"
												value="weight"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text">Show total weight</span>
										</label>
									</div>
								</div>

								<!-- Product Code -->
								<div class="col-md-4">
									<label><b>Add Product Code</b></label>
									<div class="form-group">
										<label>
											<input
												type="checkbox"
												class="input-checkbox"
												value="add_product_code"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text">{{
												$t('Add Product Code')
											}}</span>
										</label>
									</div>
								</div>

								<!-- Unboxing Instructions -->
								<div class="col-md-4">
									<label><b>Unboxing Instructions</b></label>
									<div class="form-group">
										<label>
											<input
												type="checkbox"
												class="input-checkbox"
												v-model="settingShippingLabel.unboxingInstructions"
											/>
											<span></span>
											<span class="input-checkbox-text">{{
												$t('Unboxing Instructions')
											}}</span>
										</label>
									</div>
								</div>

								<!-- Payment -->
								<!-- <div class="col-md-4">
									<label><b>Payment</b></label>
									<div class="form-group">
										<label>
											<input type="checkbox" class="input-checkbox" v-model="isShowPayment">
											<input type="checkbox" class="input-checkbox" value="payment" v-model="settings">
											<span></span>
											<span class="input-checkbox-text">Show payment method</span>
										</label>
									</div>
								</div> -->

								<!-- Order Data -->
								<div class="col-md-4">
									<label><b>Order Data</b></label>
									<div class="form-group">
										<label>
											<!-- <input type="checkbox" class="input-checkbox" v-model="isDisplayTotal"> -->
											<input
												type="checkbox"
												class="input-checkbox"
												value="total"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text"
												>Show order's total</span
											>
										</label>
									</div>
								</div>

								<!-- Shipping -->
								<div class="col-md-4">
									<label><b>Shipping</b></label>
									<div class="form-group">
										<label>
											<!-- <input type="checkbox" class="input-checkbox" v-model="isShowShipping"> -->
											<input
												type="checkbox"
												class="input-checkbox"
												value="shipping"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text">Show shipping</span>
										</label>
									</div>
								</div>

								<!-- Shipping Cost -->
								<div class="col-md-4">
									<label><b>Shipping Price</b></label>
									<div class="form-group">
										<label>
											<!-- <input type="checkbox" class="input-checkbox" v-model="isShowShippingCost"> -->
											<input
												type="checkbox"
												class="input-checkbox"
												value="shipping_cost"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text"
												>Show shipping price</span
											>
										</label>
									</div>
								</div>

								<!-- COD Label -->
								<div class="col-md-4">
									<label><b>COD</b></label>
									<div class="form-group">
										<label>
											<!-- <input type="checkbox" class="input-checkbox" v-model="isCodVisible"> -->
											<input
												type="checkbox"
												class="input-checkbox"
												value="cod"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text">Show COD Label</span>
										</label>
									</div>
								</div>

								<!-- Courier -->
								<div class="col-md-4">
									<label><b>Courier</b></label>
									<div class="form-group">
										<label>
											<!-- <input type="checkbox" class="input-checkbox" v-model="isCourierVisible"> -->
											<input
												type="checkbox"
												class="input-checkbox"
												value="courier"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text"
												>Show courier's logo</span
											>
										</label>
									</div>
								</div>

								<!-- Barcode -->
								<div class="col-md-4">
									<label><b>Barcode</b></label>
									<div class="form-group">
										<label>
											<!-- <input type="checkbox" class="input-checkbox" v-model="isShowBarcode"> -->
											<input
												type="checkbox"
												class="input-checkbox"
												value="barcode"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text">Show barcode</span>
										</label>
									</div>
								</div>

								<!-- Notes -->
								<div class="col-md-4">
									<label><b>Notes</b></label>
									<div class="form-group">
										<label>
											<input
												type="checkbox"
												class="input-checkbox"
												value="notes"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text"
												>Show Customer's Note</span
											>
										</label>
									</div>
								</div>

								<!-- Summary -->
								<div class="col-md-4">
									<label><b>Summary</b></label>
									<div class="form-group">
										<label>
											<!-- <input type="checkbox" class="input-checkbox" v-model="isInventoryVisible"> -->
											<input
												type="checkbox"
												class="input-checkbox"
												value="inventory"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text"
												>Print Order's Summary</span
											>
										</label>
									</div>
								</div>

								<!-- Handover -->
								<div class="col-md-4">
									<label
										><b>{{ $t('Handover') }}</b></label
									>
									<div class="form-group">
										<label>
											<input
												type="checkbox"
												class="input-checkbox"
												value="handover"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text">Add Handover Page</span>
										</label>
									</div>
								</div>

								<!-- Total Product -->
								<div class="col-md-4">
									<label class="flex-center">
										<b>{{ $t('Total Product') }}</b>
										<i class="material-icons md-18 ml-1" v-tooltip="'Aktif: Menggunakan informasi Additional PCS dari editor produk<br>Tidak Aktif: Mengikuti jumlah qty yang dibeli oleh pengguna'">info</i>
									</label>
									<div class="form-group">
										<label>
											<input
												type="checkbox"
												class="input-checkbox"
												v-model="settingShippingLabel.usePcsInformation"
											/>
											<span></span>
											<span class="input-checkbox-text">Use Additional PCS Information</span>
										</label>
									</div>
								</div>

								<!-- Fragile -->
								<div class="col-md-4" v-if="template === 'default'">
									<label><b>Fragile</b></label>
									<div class="form-group">
										<label>
											<!-- <input type="checkbox" class="input-checkbox" v-model="isFragile"> -->
											<input
												type="checkbox"
												class="input-checkbox"
												value="fragile"
												v-model="settings"
											/>
											<span></span>
											<span class="input-checkbox-text"
												>Print fragile signs</span
											>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-6" v-if="isPreviewVisible">
				<iframe
					:src="preview"
					frameborder="0"
					framemargin="0"
					class="preview-pane"
					id="packing-slip-preview"
				>
				</iframe>
			</div>
		</div>
		<div slot="footer">
			<button class="btn btn-light" @click="$emit('close')">
				{{ $t('Cancel') }}
			</button>
			<button class="btn btn-light" @click="setSender">Reset Sender</button>
			<button class="btn btn-light" @click="togglePreview">
				<template v-if="!isPreviewVisible">
					<i class="material-icons">visibility</i>
					<span>{{ $t('Show Preview') }}</span>
				</template>
				<template v-if="isPreviewVisible">
					<i class="material-icons">visibility_off</i>
					<span>{{ $t('Hide Preview') }}</span>
				</template>
			</button>
			<!-- Download Summary -->
			<button
				class="btn btn-light"
				:class="{ 'is-loading': isPrinting }"
				@click="generateSummary(true)"
			>
				<i class="material-icons">cloud_download</i>
				<span>Download Summary</span>
			</button>
			<!-- Download -->
			<button
				class="btn btn-primary"
				:class="{
					'is-loading': isPrinting,
					disabled: invalidOrders.length > 0,
				}"
				:disabled="invalidOrders.length > 0"
				@click="generate(true)"
			>
				<i class="material-icons">cloud_download</i>
				<span>Download PDF</span>
			</button>
		</div>
	</modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as jsPDF from 'jspdf';
// import localforage from 'localforage';
import dayjs from 'dayjs';
import Modal from '@/components/Modal.vue';
import { s3Url, pageFormats } from '@/lib/statics';
import {
	duplicateVar,
	formatNumberPlain,
	getCourierLabel,
	groupOrdersByCourier,
	imageURLtoBase64,
} from '@/lib/helper';
import {
	// eslint-disable-next-line
	generatePackingSlip,
	generatePackingSlipThermal,
	generateLayoutSix,
} from '@/lib/doc';
import userApi from '@/api/user';
import submissionsApi from '@/api/submissions';

export default {
	name: 'PackingSlipModal',
	props: {
		// logo: {},
		store: {},
		orders: {
			type: Array,
			default: () => [],
		},
		teamMembers: {
			type: Array,
			default: () => [],
		},
		courierLogos: {
			type: Array,
			default: () => [],
		},
		ooLogo: {
			type: Object,
		},
		orderonlineLogo: {
			type: Object,
		},
		labels: {
			type: Array,
			default: () => [],
		},
		productCodes: {
			type: Array,
			default: () => [],
		},
		selectedSubmissions: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			isPrinting: false,
			isPreviewVisible: true,
			sender: {},
			logo: null,
			settingShippingLabel: {
				senderAddress: false,
				senderPhone: true,
				unboxingInstructions: false,
				useProductSupplierName: false,
				usePcsInformation: true,
			},
			settings: [
				// 'logo',
				'product',
				// 'fragile',
				// 'total',
				// 'payment',
				'shipping',
				// 'shipping_cost',
				'barcode',
				// 'inventory',
				'weight',
				'cod',
				'courier',
				'sender_address',
				// 'oo_logo',
				'handover',
				'instructions',
			],
			preview: '',
			templates: [
				{ value: 'default', label: 'Layout 1' },
				{ value: 'boxed', label: 'Layout 2' },
				{ value: 'thermal', label: 'Layout 3' },
				{ value: 'thermal-small', label: 'Layout 4' },
				{ value: 'thermal-large', label: 'Layout 5 (100mm x 150mm)' },
				{ value: 'thermal-layout-6', label: 'Layout 6' },
			],
			template: 'default',
			senderSource: 'store',
		};
	},
	methods: {
		...mapActions({
			updatePrinted: 'submissions/updatePrinted',
		}),
		async b64toUrl(base64Data) {
			const r = await fetch(base64Data);
			const blob = await r.blob();
			return URL.createObjectURL(blob);
		},
		generateSummary(download = true) {
			this.isPrinting = true;
			const today = dayjs().format('YYYY-MM-DD');
			const timestamp = new Date().getTime();
			const filename = `Orders-Summary-${today}-${timestamp}.pdf`;
			let pageOption = this.template === 'thermal' ? 'label' : 'a4';
			const isThermalSmall = this.template === 'thermal-small';
			if (isThermalSmall) {
				pageOption = 'labelSmall';
			}

			const pageFormat = pageFormats[pageOption];
			const orientation = isThermalSmall ? 'landscape' : 'p';

			const jsPdfOptions = {
				orientation,
				unit: 'pt',
				format: pageFormat,
			};

			// const doc = new jsPDF('p', 'pt', pageFormat);
			// eslint-disable-next-line
			const doc = new jsPDF(jsPdfOptions);
			doc.setFont('helvetica');

			const store = duplicateVar(this.sender);

			const products = [];

			const filteredSubmissions = this.orders.reduce((acc, current) => {
				const order = acc.find(item => item._id === current._id);
				const filtered = order ? acc : acc.concat([current]);
				return filtered;
			}, []);

			filteredSubmissions.forEach((order) => {
				let productVariations = [];
				let productQuantity = order.customer_data.quantity || 1;

				if (order.customer_data.variations) {
					productVariations = order.customer_data.variations.map(
						(productVariation) => {
							const variation = {
								name: productVariation.value,
								quantity: productVariation.quantity,
							};
							return variation;
						},
					);
					productQuantity = productVariations.reduce(
						(value, variation) => value + variation.quantity,
						0,
					);
				} else if (order.customer_data.variation) {
					productVariations = [
						{
							name: order.customer_data.variation,
							quantity: productQuantity,
						},
					];
				}

				const product = {
					id: order.product_id,
					order_id: order._id,
					name: order.product_name,
					quantity: productQuantity,
					variations: productVariations,
				};

				products.push(product);
			});

			const summaryConfig = {
				isNewPage: false,
				isSmall: isThermalSmall,
			};

			this.addProductsInfoPage(doc, store, products, summaryConfig);

			if (download) {
				doc.save(filename);
			}

			this.isPrinting = false;
		},
		async generate(download = false) {
			if (!download && !this.isPreviewVisible) {
				return;
			}

			this.isPrinting = true;

			// Track
			this.$gtm.trackEvent({
				event: 'interaction', // Event type [default = 'interaction'] (Optional)
				category: 'Orders',
				action: 'click',
				label: 'Download Packing Slip',
				value: 'test',
				noninteraction: true, // Optional
			});
			this.$track('PACKING_SLIP_DOWNLOAD');

			const store = duplicateVar(this.sender);
			const today = dayjs().format('YYYY-MM-DD');
			const timestamp = new Date().getTime();
			const filename = `Shipping-Label-${today}-${timestamp}.pdf`;
			const isFragile = this.isFragile;
			const isShowProductInformation = this.isShowProductInformation;
			const isDisplayTotal = this.isDisplayTotal;
			const isShowPayment = this.isShowPayment;
			const isShowShipping = this.isShowShipping;
			const isShowShippingCost = this.isShowShippingCost;
			const isShowBarcode = this.isShowBarcode;
			const isWeightVisible = this.isWeightVisible;
			const isCodVisible = this.isCodVisible;
			const isCourierVisible = this.isCourierVisible;
			const isSenderAddressVisible = this.isSenderAddressVisible;
			const isSenderPhoneVisible = this.isSenderPhoneVisible;
			const isUnboxingInstructionsVisible = this.isUnboxingInstructionsVisible;
			const isUseProductCode = this.isUseProductCode;
			const isUseProductSupplierName = this.isUseProductSupplierName;
			const isUsePcsInformation = this.isUsePcsInformation;
			const settings = this.settings;
			const logo = this.logo;
			const isShowLogo = this.logo && this.isShowLogo;
			const members = this.teamMembers;
			const ooLogo = this.ooLogo;
			const orderonlineLogo = this.orderonlineLogo;
			const selectedSubmissions = this.selectedSubmissions;

			let pageOption = this.template === 'thermal' ? 'label' : 'a4';
			const isThermalSmall = this.template === 'thermal-small';
			if (isThermalSmall) {
				pageOption = 'labelSmall';
			} else if (this.template === 'thermal-large' || this.template === 'thermal-layout-6') {
				pageOption = 'labelLarge';
			}

			const pageFormat = pageFormats[pageOption];
			const orientation = isThermalSmall ? 'landscape' : 'p';

			const jsPdfOptions = {
				orientation,
				unit: 'pt',
				format: pageFormat,
			};

			// const doc = new jsPDF('p', 'pt', pageFormat);
			// eslint-disable-next-line
			const doc = new jsPDF(jsPdfOptions);
			doc.setFont('helvetica');

			// const slipPerpage = 5;
			let baseX = 0;
			let baseY = 0;
			let prevBaseY = 0;

			const submissionIds = [];
			const products = [];

			const filteredSubmissions = this.orders.reduce((acc, current) => {
				const order = acc.find(item => item._id === current._id);
				const filtered = order ? acc : acc.concat([current]);
				return filtered;
			}, []);

			const params = {
				doc,
				// order,
				store,
				baseY,
				isFragile,
				isShowLogo,
				logo,
				isShowProductInformation,
				isDisplayTotal,
				isShowPayment,
				isShowShipping,
				isShowShippingCost,
				isShowBarcode,
				members,
				isWeightVisible,
				isCodVisible,
				isSenderAddressVisible,
				isSenderPhoneVisible,
				isUnboxingInstructionsVisible,
				isUseProductCode,
				isUseProductSupplierName,
				isUsePcsInformation,
				selectedSubmissions,
				isCourierVisible,
				courierLogos: this.courierLogos,
				settings,
				ooLogo,
				pageFormat,
				template: this.template,
				isLast: false,
				productCodes: this.productCodes,
			};

			if (this.isInstructionsVisible) {
				const instructions = [
					'Mohon konfirmasikan dulu pada pengirim sebelum meretur barang.',
					'Mohon kontak penerima sebelum mengantarkan barang.',
				];

				params.instructions = instructions;
			}

			const ordersLength = filteredSubmissions.length;

			filteredSubmissions.forEach((order, index) => {
				// if (index !== 0 && index % slipPerpage === 0) {
				// 	doc.addPage();
				// 	baseY = 0;
				// }
				params.order = order;
				params.baseX = baseX;
				params.baseY = baseY;
				params.prevBaseY = prevBaseY;
				params.isLast = index === ordersLength - 1;
				// baseY = generatePackingSlip(params);

				// Check Source
				if (order.source_type === 'orderonline') {
					params.ooLogo = orderonlineLogo;
					if (order.store) {
						params.store = order.store;
					}
				}

				// Add Label Data if Courier is JX
				if (
					order.shipping
					&& order.shipping.courier
					&& order.shipping.courier === 'jx'
				) {
					// eslint-disable-next-line camelcase
					const labelData = this.labels.find(
						// eslint-disable-next-line camelcase
						({ order_id }) => order_id === order.order_id,
					);
					if (labelData) {
						params.labelData = labelData;
					}
				}

				let generated = { baseX: 0, baseY: 0 };
				if (
					this.template === 'boxed'
					|| this.template === 'thermal'
					|| this.template === 'thermal-small'
					|| this.template === 'thermal-large'
				) {
					generated = generatePackingSlipThermal(params);
				} else if (this.template === 'thermal-layout-6') {
					generated = generateLayoutSix(params);
				} else {
					generated = generatePackingSlip(params);
				}
				baseX = generated.baseX;
				baseY = generated.baseY;
				prevBaseY = generated.prevBaseY || 0;

				let productVariations = [];
				let productQuantity = order.customer_data.quantity || 1;

				if (order.customer_data.variations) {
					productVariations = order.customer_data.variations.map(
						(productVariation) => {
							const variation = {
								name: productVariation.value,
								quantity: productVariation.quantity,
							};
							return variation;
						},
					);
					productQuantity = productVariations.reduce(
						(value, variation) => value + variation.quantity,
						0,
					);
				} else if (order.customer_data.variation) {
					productVariations = [
						{
							name: order.customer_data.variation,
							quantity: productQuantity,
						},
					];
				}

				const product = {
					id: order.product_id,
					name: order.product_name,
					quantity: productQuantity,
					variations: productVariations,
					order_id: order._id,
				};

				products.push(product);

				submissionIds.push(order._id);
			});

			// Add Products Quantity Info
			if (this.isInventoryVisible) {
				const summaryConfig = {
					isNewPage: true,
					isSmall: isThermalSmall,
				};
				this.addProductsInfoPage(doc, store, products, summaryConfig);
			}

			// Handover Page
			if (this.isHandoverVisible) {
				const handOverConfig = {
					isNewPage: true,
					isSmall: isThermalSmall,
				};
				const groupedOrders = groupOrdersByCourier(filteredSubmissions);
				const ordersCouriers = Object.keys(groupedOrders);

				for (let index = 0; index < ordersCouriers.length; index++) {
					// doc.addPage();
					const orderCourier = ordersCouriers[index];
					const orders = groupedOrders[orderCourier] || [];
					this.addHandoverPages(
						doc,
						store,
						orders,
						orderCourier,
						handOverConfig,
					);
				}
			}

			if (download) {
				doc.save(filename);
				// Update Order Printed Status
				const updatePrintCallback = () => {
					this.updatePrinted(submissionIds);
				};
				submissionsApi.updatePrinted(submissionIds, updatePrintCallback);
			} else {
				const pdfDataUri = doc.output('datauristring', { filename });

				// using base64
				// const pdfDataSrc = pdfDataUri.replace(
				// 	'data:application/pdf',
				// 	'data:application/pdf;toolbar=0',
				// ); // Hide the iframe toolbar
				// this.preview = pdfDataSrc;

				// using blob
				const preview = await this.b64toUrl(pdfDataUri);
				this.preview = preview;

				// let preview = document.getElementById('packing-slip-preview');
				// if (preview) {
				// 	preview.setAttribute('src', pdfDataSrc);
				// } else {
				// 	setTimeout(() => {
				// 		preview = document.getElementById('packing-slip-preview');
				// 		if (preview) preview.setAttribute('src', pdfDataUri);
				// 	}, 200);
				// }
			}

			this.isPrinting = false;
		},
		addProductsInfoPage(doc, store, products, config = {}) {
			const {
				isNewPage = true,
				// page = 1,
				// totalPage = 1,
			} = config;

			// Combine Products
			const combinedProducts = [];
			products.forEach((product) => {
				const index = combinedProducts.findIndex(
					combinedProduct => combinedProduct.id === product.id,
				);
				if (index === -1) {
					combinedProducts.push(product);
				} else {
					combinedProducts[index].quantity += product.quantity;
					// Combine Variations
					product.variations.forEach((variation) => {
						const variationIndex = combinedProducts[index].variations.findIndex(
							combinedVariation => combinedVariation.name === variation.name,
						);
						if (variationIndex === -1) {
							combinedProducts[index].variations.push(variation);
						} else {
							combinedProducts[index].variations[variationIndex].quantity
								+= variation.quantity;
						}
					});
				}
			});

			// if (isNewPage) {
			// 	doc.addPage();
			// }

			const pageHeight =
				doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
			const fontSize = 25;
			const splitBy = Math.ceil(pageHeight / fontSize) * 0.6;
			const totalPages = Math.ceil(combinedProducts.length / splitBy);
			for (let index = 0; index < totalPages; index++) {
				const start = index * splitBy;
				const end = start + splitBy;
				const visibleProducts = combinedProducts.slice(start, end);
				if (!(isNewPage === false && index === 0)) {
					doc.addPage();
				}
				this.addOrderSummaryPage(doc, store, visibleProducts, config);
			}

			// this.addOrderSummaryPage(doc, store, visibleProducts, config);
		},
		addOrderSummaryPage(doc, store, products, config) {
			const { isSmall = false } = config;

			const baseX = 0;
			const baseY = 0;

			// const topPadding = 40;
			// const leftPadding = 30;
			// const lineHeight = 12;
			// const newLineMargin = 3;

			const topPadding = isSmall ? 13 : 40;
			const leftPadding = isSmall ? 10 : 30;
			const lineHeight = isSmall ? 5.5 : 12;
			const newLineMargin = isSmall ? 1.5 : 3;

			const pageWidth =
				doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
			// const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
			const xPos = baseX + leftPadding;
			const yPos = baseY + topPadding;
			const xPosStore = xPos;
			const yPosStore = yPos;
			const xPosDate = pageWidth - leftPadding;
			const yPosDate = yPos;
			const xPosLine = xPos;
			const yPosLine = yPosStore + lineHeight;
			const xPosLine2 = pageWidth - leftPadding;
			const xPosProduct = xPos;
			let yPosProduct = yPosLine + lineHeight * 2;

			// const date = this.moment().format('DD-MM-YYYY HH:mm:ss');
			const date = dayjs().format('DD-MM-YYYY HH:mm:ss');

			doc.setFontSize(10);
			doc.setFontType('bold');

			// Store Name
			doc.text(store.name, xPosStore, yPosStore);

			doc.setFontType('normal');

			// Date
			doc.text(date, xPosDate, yPosDate, { align: 'right' });

			// Line
			doc.line(xPosLine, yPosLine, xPosLine2, yPosLine);

			// Products
			for (let index = 0; index < products.length; index++) {
				const product = products[index];
				let productText = '';
				if (this.isUseProductSupplierName) {
					const submission = this.selectedSubmissions.find(sub => sub._id === product.order_id);
					productText = `${submission?.product_name} (x${product.quantity})`;
				} else {
					productText = `${product.name} (x${product.quantity})`;
				}

				doc.setFontSize(8);
				doc.text(productText, xPosProduct, yPosProduct);

				doc.setFontSize(6);

				// Variations
				for (
					let variationIndex = 0;
					variationIndex < product.variations.length;
					variationIndex++
				) {
					yPosProduct += lineHeight + newLineMargin;
					const variation = product.variations[variationIndex];
					const variationText = `- ${variation.name} (x${variation.quantity})`;
					doc.text(variationText, xPosProduct, yPosProduct);
				}

				yPosProduct += lineHeight * 1.5;
			}
		},
		addHandoverPages(doc, store, orders, orderCourier, config = {}) {
			const {
				isNewPage = true,
				// page = 1,
				// totalPage = 1,
			} = config;

			const pageHeight =
				doc.internal.pageSize.height || doc.internal.pageSize.getHeight();

			config.pageHeight = pageHeight;

			const fontSize = 8;
			const headerHeight = 52;
			const footerHeight = 150;
			const contentHeight = pageHeight - headerHeight - footerHeight;
			const splitBy = Math.ceil(contentHeight / fontSize);
			const totalPages = Math.ceil(orders.length / splitBy);
			let lastNumber = 0;

			for (let index = 0; index < totalPages; index++) {
				const start = index * splitBy;
				const end = start + splitBy;
				const visibleOrders = orders.slice(start, end);
				if (!(isNewPage === false && index === 0)) {
					doc.addPage();
				}

				const isLastPage = index === totalPages - 1;

				config.page = index + 1;
				config.totalPages = totalPages;
				config.isLastPage = isLastPage;
				config.prevNumber = parseInt(lastNumber);

				lastNumber = this.addHandoverPage(
					doc,
					store,
					visibleOrders,
					orderCourier,
					config,
				);
			}
		},
		addHandoverPage(doc, store, orders, courierCode, config = {}) {
			const {
				isSmall = false,
				isLastPage = false,
				pageHeight = 100,
				page = 1,
				totalPages = 1,
				prevNumber = 0,
			} = config;

			const baseX = 0;
			const baseY = 0;

			const topPadding = isSmall ? 10 : 40;
			const leftPadding = isSmall ? 5 : 30;
			const lineHeight = isSmall ? 5.5 : 12;

			const pageWidth =
				doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
			const xPos = baseX + leftPadding;
			const yPos = baseY + topPadding;
			const xPosStore = xPos;
			const yPosStore = yPos;
			const xPosDate = pageWidth - leftPadding;
			const yPosDate = yPos;
			const xPosLine = xPos;
			const yPosLine = yPosStore + lineHeight;
			const xPosLine2 = pageWidth - leftPadding;
			const xPosOrder = xPos;
			let yPosOrder = yPosLine + lineHeight * 1.5;

			const date = dayjs().format('DD-MM-YYYY HH:mm:ss');

			doc.setFontSize(8);
			// doc.setFontType('bold');

			const courierLabel = getCourierLabel(courierCode);
			const pageTitle = `${courierLabel} (Page ${page} of ${totalPages} )`;

			// Page Title
			doc.text(pageTitle, xPosStore, yPosStore);

			doc.setFontType('normal');

			// Date
			doc.text(date, xPosDate, yPosDate, { align: 'right' });

			// Line
			doc.line(xPosLine, yPosLine, xPosLine2, yPosLine);

			let shippingCostTotal = 0;

			const xPosNo = xPosOrder;
			const xPosOrderId = xPosNo + 15;
			const xPosResi = xPosOrderId + 50;
			const xPosOngkir = xPosResi + 90;

			let number = 0;

			// Orders
			for (let index = 0; index < orders.length; index++) {
				number = `${index + prevNumber + 1}.`;
				const order = orders[index];
				// eslint-disable-next-line camelcase
				const orderId = order.order_id ? `#${order.order_id}` : '';
				// eslint-disable-next-line camelcase
				let receiptNumber = order?.shipping?.receipt_number ?? '-';
				receiptNumber = `Resi: ${receiptNumber}`;
				// eslint-disable-next-line camelcase
				let shippingCost =
					order?.shipping?.original_cost ?? order?.shipping?.cost;
				shippingCostTotal += shippingCost;
				shippingCost = formatNumberPlain(shippingCost);
				shippingCost = `Ongkir: ${shippingCost}`;

				// No.
				doc.text(number, xPosNo, yPosOrder);
				// Order ID
				doc.text(orderId, xPosOrderId, yPosOrder);
				// Resi
				doc.text(receiptNumber, xPosResi, yPosOrder);
				// Ongkir
				doc.text(shippingCost, xPosOngkir, yPosOrder);

				yPosOrder += lineHeight * 1;
			}

			// Footer
			if (isLastPage) {
				yPosOrder += 5;
				const yPosFooter = pageHeight - 20;
				// Ongkir
				const formattedTotalShippingCost = formatNumberPlain(shippingCostTotal);
				const shippingCOstLabel = `Total: ${formattedTotalShippingCost}`;
				doc.text(shippingCOstLabel, xPosOngkir, yPosOrder);

				// Signature
				const yPosSignatureLine = yPosFooter - 13;
				const xPosSignatureLine2 = xPosNo + 40;
				doc.line(
					xPosNo,
					yPosSignatureLine,
					xPosSignatureLine2,
					yPosSignatureLine,
				);

				const signatureLabel = `${store.name}`;
				doc.text(signatureLabel, xPosNo, yPosFooter);

				// Signature - Officer
				const xPosSignatureLine4 = xPosOngkir + 40;
				doc.line(
					xPosOngkir,
					yPosSignatureLine,
					xPosSignatureLine4,
					yPosSignatureLine,
				);

				const signatureLabel2 = 'Petugas Pick Up';
				doc.text(signatureLabel2, xPosOngkir, yPosFooter);
			}

			return number;
		},
		setSender() {
			if (this.store) {
				this.sender = duplicateVar(this.store);
				if (!this.sender.website) {
					this.sender.website = '';
				}
				if (!this.sender.phone) {
					this.sender.phone = '';
				}
			}
		},
		onLogoLoaded() {
			const url = this.storeLogo;
			if (url && url !== '') {
				const callback = (image) => {
					this.logo = image;
					this.generate();
				};
				imageURLtoBase64(url, callback);
			}
		},
		togglePreview() {
			this.isPreviewVisible = !this.isPreviewVisible;
			this.generate();
		},
		// Update Settings
		updateSettings() {
			// const userSettings = duplicateVar(this.userSettings);
			const userSettings = {};
			const packingSlipSettings = duplicateVar(this.settings);
			userSettings.packingSlip = packingSlipSettings;
			userSettings.packingSlipLayout = this.template;
			userSettings.settingShippingLabel = this.settingShippingLabel;
			userApi.updateSettings(userSettings);
			// const localSettings = duplicateVar(userSettings);
			// localforage.setItem('settings', localSettings);
		},
		setSettings() {
			const packingSlipSettings =
				this.userSettings && this.userSettings.packingSlip
					? this.userSettings.packingSlip
					: null;
			const layout =
				this.userSettings && this.userSettings.packingSlipLayout
					? this.userSettings.packingSlipLayout
					: null;

			const settingShippingLabel =
				this.userSettings && this.userSettings.settingShippingLabel
					? this.userSettings.settingShippingLabel
					: null;

			if (layout) {
				const templateValues = this.availableTemplates.map(
					({ value }) => value,
				);
				if (templateValues.includes(layout)) {
					this.template = layout;
				} else {
					this.template = 'thermal';
				}
			}
			if (packingSlipSettings) {
				this.settings = packingSlipSettings;
			}

			if (settingShippingLabel) {
				this.settingShippingLabel = duplicateVar(settingShippingLabel);
			}
		},
		onSenderNameChange() {
			this.generate();
		},
		onSenderPhoneChange() {
			this.generate();
		},
		onLayoutChange() {
			this.updateSettings();
		},
		onSenderChange(event) {
			const value = event.target.value;
			if (value === 'store') {
				this.setSender();
			} else if (value === 'cs') {
				this.sender.name = '{{cs_name}}';
				this.sender.phone = '{{cs_phone}}';
			}
			this.generate();
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			userSettings: 'settings',
			isHasFeature: 'isHasFeature',
		}),
		size() {
			const size = this.isPreviewVisible ? 'full' : 'large';
			return size;
		},
		storeLogo() {
			let url = this.store ? this.store.logo : '';
			url = url.replace('https://cdn.orderonline.id', s3Url);
			return url;
		},
		isFragile() {
			return this.settings.includes('fragile');
		},
		isShowLogo() {
			return this.settings.includes('logo') && this.storeLogo !== '';
		},
		isShowProductInformation() {
			return this.settings.includes('product');
		},
		isDisplayTotal() {
			return this.settings.includes('total');
		},
		isShowPayment() {
			return this.settings.includes('payment');
		},
		isShowShipping() {
			return this.settings.includes('shipping');
		},
		isShowShippingCost() {
			return this.settings.includes('shipping_cost');
		},
		isShowBarcode() {
			return this.settings.includes('barcode');
		},
		isInventoryVisible() {
			return this.settings.includes('inventory');
		},
		isWeightVisible() {
			return this.settings.includes('weight');
		},
		isCodVisible() {
			return this.settings.includes('cod');
		},
		isCourierVisible() {
			return this.settings.includes('courier');
		},
		isSenderAddressVisible() {
			return this.settingShippingLabel.senderAddress;
			// return this.settings.includes('sender_address');
		},
		isSenderPhoneVisible() {
			return this.settingShippingLabel.senderPhone;
		},
		isUnboxingInstructionsVisible() {
			return this.settingShippingLabel.unboxingInstructions;
		},
		isUseProductSupplierName() {
			return this.settingShippingLabel.useProductSupplierName;
		},
		isUsePcsInformation() {
			return this.settingShippingLabel.usePcsInformation;
		},
		isHandoverVisible() {
			return this.settings.includes('handover');
		},
		isInstructionsVisible() {
			return this.settings.includes('instructions');
		},
		isUseProductCode() {
			return this.settings.includes('hide_product_name');
		},
		invalidOrders() {
			const validCouriers = ['sicepat', 'jne'];
			const filter = (curr) => {
				const isCod = curr.shipping && curr.shipping.cod;
				const isCourierMatch =
					curr.shipping && validCouriers.includes(curr.shipping.courier);
				const receiptNumberEmpty =
					curr.shipping
					&& (!curr.shipping.receipt_number
						|| curr.shipping.receipt_number === '');
				return isCod && isCourierMatch && receiptNumberEmpty;
			};
			const orders = this.orders.filter(filter);
			return orders;
		},
		hasJxCourier() {
			const jxOrders = this.orders.filter(
				({ shipping }) => shipping.courier === 'jx',
			);
			return jxOrders.length > 0;
		},
		availableTemplates() {
			let filteredTemplates = this.templates;
			if (this.hasJxCourier) {
				// Exclude default template and template layout 4
				filteredTemplates = this.templates.filter(
					({ value }) => value === 'thermal-large' || value === 'thermal-layout-6',
				);
			}
			return filteredTemplates;
		},
	},
	created() {
		if (this.orders.length > 10) {
			this.isPreviewVisible = false;
		}
	},
	mounted() {
		this.setSettings();
		this.setSender();
		this.generate();
	},
	watch: {
		isShowLogo() {
			this.generate();
		},
		isFragile() {
			this.generate();
		},
		isShowProductInformation() {
			this.generate();
		},
		isDisplayTotal() {
			this.generate();
		},
		isShowPayment() {
			this.generate();
		},
		isShowShipping() {
			this.generate();
		},
		isShowShippingCost() {
			this.generate();
		},
		isShowBarcode() {
			this.generate();
		},
		isInventoryVisible() {
			this.generate();
		},
		isWeightVisible() {
			this.generate();
		},
		isCodVisible() {
			this.generate();
		},
		isCourierVisible() {
			this.generate();
		},
		isSenderAddressVisible() {
			this.updateSettings();
			this.generate();
		},
		isSenderPhoneVisible() {
			this.updateSettings();
			this.generate();
		},
		isUnboxingInstructionsVisible() {
			this.updateSettings();
			this.generate();
		},
		isUseProductSupplierName() {
			this.updateSettings();
			this.generate();
		},
		isUsePcsInformation() {
			this.updateSettings();
			this.generate();
		},
		settings() {
			this.updateSettings();
			this.generate();
		},
		template() {
			// this.updateSettings();
			this.generate();
		},
	},
};
</script>
